
/* User defined models */
import { Address } from './address.model'
import { Contact } from './contact.model'
import { Direction } from './direction.model'

// TODO: merge this with the location in client
export class SiteLocation {
  address: Address;
  coordinates: number[];
  contact: Contact;
  directions: Direction[];
  distance: number;

  constructor(
    address: Address,
    coordinates: number[],
    contact: Contact,
    directions: Direction[],
    distance?: number
  ) {
    this.address = address;
    this.coordinates = coordinates;
    this.contact = contact;
    this.directions = directions;
    this.distance = distance;
  }
}